import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button, Select } from "components"
import { DEFAULT_THRESHOLD_NORMAL } from "constants/layout"
import { Radium } from "higher-order-components"
import { noop, pick } from "utils"

const FILTER_PROPS = ["nameplate", "body", "grade", "engine"]

export class ServiceCalculatorFilter extends Component {
  constructor(props) {
    super(props)

    this.state = { activeService: 0, ...this.getFilterStateFromProps(props) }

    this.handleSubmit = () => {
      const selection = this.getSelection()
      this.props.onSubmit(selection.modelCode, selection.selection)
    }

    this.handleChange = () => {
      if (!this.props.onChange) return
      const { modelCode, selection } = this.getSelection()
      this.props.onChange(modelCode, selection)
    }

    this.getSelection = () => {
      const data = this.props.vehiclesData
      const selection = []
      let modelCode
      if (this.state.nameplate < 0) {
        return { modelCode, selection }
      }
      selection.push(data.namePlates[this.state.nameplate].name)
      if (this.state.body < 0) {
        return { modelCode, selection }
      }
      selection.push(data.namePlates[this.state.nameplate].bodyStyles[this.state.body].name)
      if (this.state.grade < 0) {
        return { modelCode, selection }
      }
      selection.push(data.namePlates[this.state.nameplate].bodyStyles[this.state.body].grades[this.state.grade]
        .name)
      if (this.state.engine < 0) {
        return { modelCode, selection }
      }
      selection.push(data.namePlates[this.state.nameplate].bodyStyles[this.state.body].grades[this.state.grade]
        .modelCodes[this.state.engine].description)
      modelCode =
        data.namePlates[this.state.nameplate].bodyStyles[this.state.body].grades[this.state.grade]
          .modelCodes[this.state.engine].code

      return { modelCode, selection }
    }

    this.setNameplate = (v) => {
      if (!v) {
        this.setState(
          {
            nameplate: -1,
            body: -1,
            grade: -1,
            engine: -1
          },
          this.handleChange
        )
        return
      }
      const data = this.props.vehiclesData
      const newValue = data.namePlates.findIndex(d => d.name === v.name)
      const numBodies = data.namePlates[newValue].bodyStyles.length
      this.setState(
        {
          nameplate: newValue,
          body: numBodies > 1 ? -1 : 0,
          grade: -1,
          engine: -1
        },
        this.handleChange
      )
    }

    this.setBody = (v) => {
      if (!v) {
        this.setState(
          {
            body: -1,
            grade: -1,
            engine: -1
          },
          this.handleChange
        )
        return
      }
      const data = this.props.vehiclesData
      const newValue = data.namePlates[this.state.nameplate].bodyStyles.findIndex(d => d.name === v.name)
      const numGrades = data.namePlates[this.state.nameplate].bodyStyles[newValue].grades.length
      this.setState(
        {
          body: newValue,
          grade: numGrades > 1 ? -1 : 0,
          engine: -1
        },
        this.handleChange
      )
    }

    this.setGrade = (v) => {
      if (!v) {
        this.setState(
          {
            grade: -1,
            engine: -1
          },
          this.handleChange
        )
        return
      }
      const data = this.props.vehiclesData
      const newValue = data.namePlates[this.state.nameplate].bodyStyles[
        this.state.body
      ].grades.findIndex(d => d.name === v.name)
      const numEngines =
        data.namePlates[this.state.nameplate].bodyStyles[this.state.body].grades[newValue]
          .modelCodes.length
      this.setState(
        {
          grade: newValue,
          engine: numEngines > 1 ? -1 : 0
        },
        this.handleChange
      )
    }

    this.setEngine = (v) => {
      if (!v) {
        this.setState({ engine: -1 }, this.handleChange)
        return
      }
      const data = this.props.vehiclesData
      const newValue = data.namePlates[this.state.nameplate].bodyStyles[this.state.body].grades[
        this.state.grade
      ].modelCodes.findIndex(d => d.description === v.name)
      this.setState(
        {
          engine: newValue
        },
        this.handleChange
      )
    }
  }

  getFilterStateFromProps({ vehiclesData: data = {}, selection = [] }, currentState) {
    const [nameplate, body, grade, engine] = selection || []
    const newState = currentState
      ? pick(FILTER_PROPS, currentState)
      : FILTER_PROPS.reduce((obj, key) => ({ ...obj, [key]: -1 }), {})

    newState.nameplate = data.namePlates.findIndex(d => d.name === nameplate)

    if (newState.nameplate !== -1) {
      newState.body = data.namePlates[newState.nameplate].bodyStyles.findIndex(d => d.name === body)
    }

    if (newState.body !== -1) {
      newState.grade = data.namePlates[newState.nameplate].bodyStyles[
        newState.body
      ].grades.findIndex(d => d.name === grade)
    }

    if (newState.grade !== -1) {
      newState.engine = data.namePlates[newState.nameplate].bodyStyles[newState.body].grades[
        newState.grade
      ].modelCodes.findIndex(d => d.description === engine)
    }

    return newState
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      ...this.state,
      ...this.getFilterStateFromProps(newProps, this.state)
    })
  }

  renderFilters() {
    const { vehiclesData: data } = this.props
    const {
      nameplate, body, grade, engine
    } = this.state
    const pickName = pick(["name"])

    const nameplateOptions = data.namePlates.map(pickName)

    const bodyOptions = nameplate !== -1 ? data.namePlates[nameplate].bodyStyles.map(pickName) : []

    const gradeOptions =
      nameplate !== -1 && body !== -1
        ? data.namePlates[nameplate].bodyStyles[body].grades.map(pickName)
        : []

    const engineOptions =
      nameplate !== -1 && body !== -1 && grade !== -1
        ? data.namePlates[nameplate].bodyStyles[body].grades[
          grade
        ].modelCodes.map(({ description }) => ({ name: description }))
        : []

    return (
      <div style={styles.filtersGroup}>
        <div style={styles.selectFilterFirst}>
          <Select
            ref={(e) => {
              this.nameplateSelect = e
            }}
            label="Model"
            active={nameplate}
            options={nameplateOptions}
            onChange={this.setNameplate} />
        </div>
        <div style={styles.selectFilter}>
          <Select
            ref={(e) => {
              this.bodySelect = e
            }}
            label="Body"
            active={body}
            disabled={nameplate === -1 || bodyOptions.length < 2}
            options={bodyOptions}
            onChange={this.setBody} />
        </div>
        <div style={styles.selectFilter}>
          <Select
            ref={(e) => {
              this.gradeSelect = e
            }}
            label="Grade"
            active={grade}
            disabled={body === -1}
            options={gradeOptions}
            onChange={this.setGrade} />
        </div>
        <div style={styles.selectFilterLast}>
          <Select
            ref={(e) => {
              this.engineSelect = e
            }}
            label="Engine"
            active={engine}
            disabled={grade === -1}
            options={engineOptions}
            onChange={this.setEngine} />
        </div>
      </div>
    )
  }

  render() {
    const { selection } = this.getSelection()

    return (
      <div style={styles.base}>
        {this.renderFilters()}
        {!this.props.hideCTA && (
          <div style={styles.buttonContainer} data-name="test-test">
            <Button
              styleName="black"
              label={this.props.ctaLabel}
              onClick={this.handleSubmit}
              disabled={selection.length < FILTER_PROPS.length}
              fullWidth />
          </div>
        )}
      </div>
    )
  }
}

ServiceCalculatorFilter.propTypes = {
  vehiclesData: PropTypes.object,
  selection: PropTypes.array,
  hideCTA: PropTypes.bool,
  ctaLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func
}

ServiceCalculatorFilter.defaultProps = {
  hideCTA: false,
  ctaLabel: "Calculate",
  onSubmit: noop,
  onChange: noop
}

export default Radium(ServiceCalculatorFilter)

const breakpoint1 = `@media (min-width: ${DEFAULT_THRESHOLD_NORMAL}px)`

const styles = {
  base: {
    maxWidth: "70em",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    [breakpoint1]: {
      flexDirection: "row"
    }
  },
  filtersGroup: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    [breakpoint1]: {
      flexDirection: "row",
      marginRight: "1em"
    }
  },
  selectFilter: {
    [breakpoint1]: {
      flexGrow: 1,
      padding: "0.5em",
      width: "100%"
    },
    flexGrow: 1,
    paddingTop: "0.5em"
  },
  buttonContainer: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
  },
  selectFilterFirst: {
    [breakpoint1]: {
      flexGrow: 1,
      paddingRight: "0.5em",
      width: "120%"
    },
    width: "100%",
    flexGrow: 1,
    paddingTop: "0.5em"
  },
  selectFilterLast: {
    [breakpoint1]: {
      flexGrow: 1,
      width: "180%",
      paddingLeft: "0.5em"
    },
    width: "100%",
    flexGrow: 1,
    paddingTop: "0.5em"
  }
}



// WEBPACK FOOTER //
// ./src/containers/service-calculator-filter/index.jsx